"use client";

import React, { useState } from "react";
import { motion } from "framer-motion";

export function InfiniteSlider({
  children,
  gap = 16,
  reverse = false,
  speed = 40,
  speedOnHover,
  className = "",
}) {
  const [isHovered, setIsHovered] = useState(false);
  const duration = isHovered && speedOnHover ? speedOnHover : speed;

  const items = React.Children.toArray(children);
  const duplicated = [...items, ...items];

  return (
    <div
      className={`overflow-hidden ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <motion.div
        className="flex w-max items-center will-change-transform"
        style={{ gap: `${gap}px` }}
        animate={{
          x: reverse ? ["-50%", "0%"] : ["0%", "-50%"],
        }}
        transition={{
          duration,
          ease: "linear",
          repeat: Infinity,
        }}
      >
        {duplicated.map((child, i) => (
          <div key={i} className="flex-shrink-0">
            {child}
          </div>
        ))}
      </motion.div>
    </div>
  );
}